module.exports = __webpack_public_path__ + "static/impact-02ddd4c2f26d549769870e4e97b58afa.svg";